import { useSelector } from 'react-redux';

import usePrismicQuery from 'dpl/prismic/hooks/usePrismicQuery';

export default function usePrismicDocument() {
  const documentId = useSelector(({ queryParams }) => queryParams.documentId);

  const { isSuccess, value } = usePrismicQuery({
    id: documentId,
    defaultValue: {
      uid: null,
      type: null
    }
  });

  return {
    uid: value.uid,
    type: value.type,
    value,
    isSuccess
  };
}
